import {
    Bar,
    BarChart,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts'
import dayJs from '../../libs/dayjs'

interface OverviewProps {
    data: any
}

export default function Overview({ data }: OverviewProps) {
    return (
        <div>
            <header className="mb-4">
                <h3 className="text-lg">Gráfico</h3>
                <p className="text-sm">
                    Valores buscados a partir de:{' '}
                    {dayJs().add(5, 'day').format('DD/MM/YYYY')}
                </p>
            </header>
            <div className="overflow-x-auto max-w-[700px] max-[1200px]:max-w-[1000px] chart-scroll">
                <BarChart width={data.length * 100} height={350} data={data}>
                    <XAxis
                        dataKey="name"
                        stroke="#888888"
                        fontSize={12}
                        tickLine={false}
                        axisLine={false}
                    />
                    <YAxis
                        stroke="#888888"
                        fontSize={12}
                        tickLine={false}
                        axisLine={false}
                        tickFormatter={(value) => `R$${value}`}
                    />
                    <Tooltip
                        formatter={(value) =>
                            new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL',
                            }).format(Number(value))
                        }
                        labelFormatter={(value) => `${value}`}
                        contentStyle={{ color: '#333' }}
                    />
                    {/* <Legend
                    formatter={(value) =>
                        String(value)
                            .substring(0, 1)
                            .toUpperCase()
                            .concat(String(value).substring(1))
                    }
                    radius={40}
                /> */}
                    <Bar dataKey="livre" fill="#22c55e" radius={[4, 4, 0, 0]} />
                    <Bar
                        dataKey="movimentado"
                        fill="#ef4444"
                        radius={[4, 4, 0, 0]}
                    />
                    <Bar dataKey="total" fill="#2563eb" radius={[4, 4, 0, 0]} />
                </BarChart>
            </div>
            <div className="flex items-center justify-center mt-2 gap-4">
                <div className="flex items-center gap-1">
                    <span className="w-3 h-3 bg-[#22c55e] block rounded-sm"></span>
                    <span>Livre</span>
                </div>
                <div className="flex items-center gap-1">
                    <span className="w-3 h-3 bg-[#ef4444] block rounded-sm"></span>
                    <span>Movimentado</span>
                </div>
                <div className="flex items-center gap-1">
                    <span className="w-3 h-3 bg-[#2563eb] block rounded-sm"></span>
                    <span>Total</span>
                </div>
            </div>
        </div>
    )
}
